import dayjs from "dayjs";
import type { ITransactionDto } from "./ITransaction";
import { TransactionState } from "./TransactionState";

export const useMockPendingTransactions = () => [
    {
        advertiserName: 'MenuLog',
        title: 'MenuLog 5% Cashback',
        category: 'Service',
        logo: '/images/partners/menulog-logo.jpg',
        state: TransactionState.Pending,
        transactionDate: dayjs().add( -2, 'days' ).toISOString(),
        cashbackAmount: 3.33,
        purchaseAmount: 66.50,
    }
                
];

export const useMockTransactionData = () => [
    {
        advertiserName: "Milkrun",
        category: "Retail & Other",
        title: "Up to 5% Cashback on All Purchases",
        purchaseAmount: 187.55,
        cashbackAmount: 9.38,
        transactionDate: dayjs().add( -7, 'days' ).toISOString(),
        state: TransactionState.Clear,
        logo: "/images/partners/milkrun-logo.png"
    },
    {
        advertiserName: "MenuLog",
        category: "Food & Drinks",
        title: "MenuLog 5% Cashback",
        purchaseAmount: 149.05,
        cashbackAmount: 7.45,
        transactionDate: dayjs().add( -9, 'days' ).toISOString(),
        state: TransactionState.Clear,
        logo: "/images/partners/menulog-logo.jpg"
    },
    {
        advertiserName: "Milkrun",
        category: "Retail & Other",
        title: "Up to 5% Cashback on All Purchases",
        purchaseAmount: 62.97,
        cashbackAmount: 3.15,
        transactionDate: dayjs().add( -12, 'days' ).toISOString(),
        state: TransactionState.Clear,
        logo: "/images/partners/milkrun-logo.png"
    },
    {
        advertiserName: "Suttons Arncliffe",
        category: "Service",
        title: "Suttons Arncliffe Vehicle Service",
        purchaseAmount: 399.00,
        cashbackAmount: 31.52,
        transactionDate: dayjs().add( -1, "months" ).toISOString(),
        state: TransactionState.Clear,
        logo: "/images/partners/suttons-white.png"
    },
    {
        advertiserName: "Hertz",
        category: "Travel & Holidays",
        title: "Suttons Arncliffe Vehicle Service",
        purchaseAmount: 286.59,
        cashbackAmount: 28.66,
        transactionDate: dayjs().add( -1, "months" ).toISOString(),
        state: TransactionState.Clear,
        logo: "/images/partners/hertz-logo.png"
    }
  
] as ITransactionDto[];

export const useMockLinkedCards = () => [                
    {
        linkedCardId: '1',
        description: "Visa card",
        cardNickName: "A MCNALLY",
        cardMasked: '4882',
        issuer: 'visa',
        isDefault: true,
        expiry: dayjs().add( 13, 'months' ).format( 'YYYY/MM/01' ),
        provider: 'Commonwealth Bank',
        providerId: 2,
        isExpiring: false,
        hasExpired: false
    },
    {
        linkedCardId: '2',
        description: "Mastercard card",
        cardNickName: "A MCNALLY",
        cardMasked: '3792',
        issuer: 'mastercard',
        isDefault: true,
        expiry: dayjs().add( 7, 'months' ).format( 'YYYY/MM/01' ),
        provider: 'Commonwealth Bank',
        providerId: 3,
        isExpiring: false,
        hasExpired: false
    },
    {
        linkedCardId: '3',
        description: "Mastercard card",
        cardNickName: "A MCNALLY",
        cardMasked: '3792',
        issuer: 'mastercard',
        isDefault: true,
        expiry: dayjs().add( 1, 'months' ).format( 'YYYY/MM/01' ),
        provider: 'Commonwealth Bank',
        providerId: 3,
        isExpiring: true,
        hasExpired: false
    },
    {
        linkedCardId: '4',
        description: "Mastercard card",
        cardNickName: "A MCNALLY",
        cardMasked: '8590',
        issuer: 'mastercard',
        isDefault: true,
        expiry: dayjs().add( -1, 'months' ).format( 'YYYY/MM/01' ),
        provider: 'Commonwealth Bank',
        providerId: 3,
        isExpiring: false,
        hasExpired: true
    }
];

export const useMockBankAccount = () => { return { accountNumber: '****-***7-26', bsb: '***-736' } };
export const useMockAvailableAmount = () => 51.50;
export const useMockLifetimeAmount = () => 80.16;